import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { AccountRegistrationService } from '../../services/account-registration.service'
import { environment } from '../../../environments/environment'
import { AppInfoService } from '../../services/app-info.service'

@Component({
  selector: 'app-registration-success',
  templateUrl: './registration-success.component.html',
  styleUrls: ['./registration-success.component.scss'],
})
export class RegistrationSuccessComponent {
  constructor(
    private router: Router,
    private accountRegistrationService: AccountRegistrationService,
    private appInfoService: AppInfoService,
  ) {}
  environmentKey: 'prod' | 'dev' | null =
    environment.environmentCd === 'prod' ? 'prod' : environment.environmentCd === 'dev' ? 'dev' : null

  private readonly animationBaseUrl = 'assets/video/2_bow.webp'
  animationUrl = this.animationBaseUrl

  // 2_bow.webp はループ1回で止まるため、クリックで src を付け替えて再生し直す
  // （フラグメントだけ変えるので再ダウンロードはされない）
  replayAnimation() {
    this.animationUrl = `${this.animationBaseUrl}#${Date.now()}`
  }

  onLoginClick() {
    const dashboardUrl = this.appInfoService.AppInitializeInfo?.layout?.header?.titleLink || ''
    // ダッシュボードへ遷移
    location.href = dashboardUrl
  }
}
